import ScheduleActivityEntityItem from './ScheduleActivityEntityItem';

export default ScheduleActivityEntityItem;
